<template>
  <div class="sign-in-box">
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="form"
      @submit.prevent="validateForm()">
      <validation-provider name="email" rules="required|email" slim>
        <template slot-scope="{ errors }">
          <oie-base-input
            id="forgot-password-email"
            v-model="email"
            :label-text="`${t('email')}*`"
            :placeholder="t('emailPlaceholder')"
            :error-messages="errors"></oie-base-input>
        </template>
      </validation-provider>

      <div class="sign-in-box__actions">
        <oie-base-button
          v-element-loader="{ endpoint: 'auth/forgotPassword' }"
          button-type="button"
          :text="t('sendButton')"
          css-classes="button--with-border button--blue sign-in-box__button"
          type="submit"></oie-base-button>
      </div>

      <div>
        {{ informationText }}
      </div>
    </validation-observer>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    linkUrl: {
      type: String,
      default: ''
    },
    informationText: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    email: null
  }),
  methods: {
    async validateForm() {
      const isValid = await this.$refs.observer.validate()

      if (!isValid) {
        // ABORT

      } else {
        this.forgotPassword()
      }
    },
    forgotPassword() {
      httpService.post('auth/forgotPassword', { email: this.email }).then((response) => {
        this.linkUrl = response.data.url
        this.informationText = response.data.information
      })
    }
  }
}
</script>
